import * as request from './utils/requester';

export const getAll = (page) => request.get(`/staff?page=${page}`);

export const getById = (id) => request.get(`/staff/${id}`);

export const create = (data) => request.post('/staff', data);

export const edit = (data) => request.put(`/staff/${data._id}`, data);

export const del = (data) => request.del(`/staff/${data._id}`);


export const getOption = (option, id) => request.get(`/staff/${id}?option=${option}`);